(function () {
  "use strict";

  /* Mobile nav */
  var toggle = document.getElementById("nav-toggle");
  var nav = document.getElementById("site-nav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.addEventListener("click", function (e) {
      if (e.target.tagName === "A") nav.classList.remove("is-open");
    });
  }

  /* Halloween countdown */
  var cd = document.querySelector("[data-countdown]");
  if (cd) {
    var target = new Date(cd.getAttribute("data-countdown")).getTime();
    var nums = {
      d: cd.querySelector("[data-cd-d]"),
      h: cd.querySelector("[data-cd-h]"),
      m: cd.querySelector("[data-cd-m]"),
      s: cd.querySelector("[data-cd-s]")
    };
    var pad = function (n) { return String(n).padStart(2, "0"); };
    var tick = function () {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;
      nums.d.textContent = pad(Math.floor(diff / 864e5));
      nums.h.textContent = pad(Math.floor(diff / 36e5) % 24);
      nums.m.textContent = pad(Math.floor(diff / 6e4) % 60);
      nums.s.textContent = pad(Math.floor(diff / 1e3) % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* Bundle picker → syncs quantity into the ATC form */
  var picker = document.querySelector("[data-picker]");
  if (picker) {
    var qtyInput = document.querySelector("[data-atc-qty]");
    var stickyTotal = document.querySelector("[data-sticky-total]");
    picker.addEventListener("change", function (e) {
      var input = e.target.closest("input[type=radio]");
      if (!input) return;
      picker.querySelectorAll(".picker__opt").forEach(function (o) {
        o.classList.toggle("is-active", o.contains(input));
      });
      if (qtyInput) qtyInput.value = input.value;
      if (stickyTotal) {
        var t = input.closest(".picker__opt").getAttribute("data-total");
        if (t) stickyTotal.textContent = t;
      }
    });
  }

  /* Product gallery thumbnails */
  var mainImg = document.querySelector("[data-main-img]");
  document.querySelectorAll("[data-thumb]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!mainImg) return;
      mainImg.src = btn.getAttribute("data-thumb");
      document.querySelectorAll("[data-thumb]").forEach(function (b) {
        b.classList.remove("is-active");
      });
      btn.classList.add("is-active");
    });
  });

  /* Cart quantity buttons (submit the cart form) */
  document.querySelectorAll("[data-qty-btn]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var input = btn.parentElement.querySelector("input");
      var val = parseInt(input.value || "0", 10);
      val += btn.getAttribute("data-qty-btn") === "plus" ? 1 : -1;
      if (val < 0) val = 0;
      input.value = val;
      var form = btn.closest("form");
      if (form) form.submit();
    });
  });

  /* Reveal on scroll */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add("is-in");
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); });
  }
})();
